<template>
	<div class="mobile_home">
		<div class="mobile_home_head">
			<!-- <span class="head_logo">
				<img src="../../static/images/mobile_images/mobile_logo.png" />
			</span> -->
			<a href="http://www.fengtaoit.com/" class="head_logo">
				<img src="../../static/images/mobile_images/mobile_logo.png" />
			</a>
			<span class="head_icon" @click="showSide">
				<img src="../../static/images/mobile_images/mobile_headIcon.png" />
			</span>
		</div>
		<transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
			<div class="mobile_home_sideEdge_con" v-show="isShow" @click="closeSide">
				<div class="mobile_home_sideEdge_con_head">
					<span @click="closeSide">
						<img src="../../static/images/mobile_images/closeIcon.png" />
					</span>
				</div>
				<ul>
					<li @click="scrollTo('mobile_pattern')">
						<span class="mobile_home_sideEdge_con_icon">
							<img src="../../static/images/mobile_images/sideIcon2.png" />
						</span>
						<span class="mobile_home_sideEdge_con_title">功能介绍</span>
					</li>
					<li @click="scrollTo('mobile_pay')">
						<span class="mobile_home_sideEdge_con_icon">
							<img src="../../static/images/mobile_images/sideIcon1.png" />
						</span>
						<span class="mobile_home_sideEdge_con_title">服务价格</span>
					</li>
					<li @click="scrollTo('mobile_aboutUS')">
						<span class="mobile_home_sideEdge_con_icon">
							<img src="../../static/images/mobile_images/sideIcon3.png" />
						</span>
						<span class="mobile_home_sideEdge_con_title">联系我们</span>
					</li>
				</ul>
			</div>
		</transition>
		<div class="mobile_banner">
			<div>
				<swiper :options="swiperOption" class="swiperOption" ref="mySwiper">
					<swiper-slide><img src="../../static/images/mobile_images/banner.png" /></swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>

				</swiper>
			</div>
		</div>
		<div class="mobile_number">
			<div class="mobile_number_con">
				<div class="mobile_number_con_item item1">
					<span class="num blue companyNum">{{companyNum}}</span>
					<span class="addText blue">+</span>
					<span class="title">/ 商家入驻数</span>
				</div>
				<span class="line"></span>
				<div class="mobile_number_con_item item2">
					<span class="num green userNum">{{userNum}}</span>
					<span class="addText green">+</span>
					<span class="title">/ 用户总数</span>
				</div>
			</div>
		</div>
		<div class="mobile_introduce">
			<p class="mobile_introduce_title1">专注解决钢铁批发贸易公司开单、入库、结算难问题，帮助企业节能减排，提高企业经济效益</p>
			<p class="mobile_introduce_title2">适用于各类经营模式企业(批发、批零兼营、零售、连锁加盟、渠道分销)</p>
			<div class="mobile_introduce_itemBox">
				<div class="mobile_introduce_item">
					<img src="../../static/images/mobile_images/functionIcon1.png">
					<span>批发型</span>
				</div>
				<div class="mobile_introduce_item">
					<img src="../../static/images/mobile_images/functionIcon2.png">
					<span>批零兼售型</span>
				</div>
				<div class="mobile_introduce_item">
					<img src="../../static/images/mobile_images/functionIcon3.png">
					<span>零售型</span>
				</div>
				<div class="mobile_introduce_item">
					<img src="../../static/images/mobile_images/functionIcon4.png">
					<span>连锁加盟、渠道分销型</span>
				</div>
			</div>
		</div>
		<div class="mobile_do">
			<p class="mobile_do_title">我们能为你做什么?</p>
			<p class="mobile_do_title1">"人" "钱" "业务" 三点要素的信息化管理</p>
			<div class="mobile_do_itemBox1">
				<div class="mobile_do_itemBox1_left">
					<img src="../../static/images/mobile_images/doItem1.png" />
				</div>
				<div class="mobile_do_itemBox1_right">
					<p class="title">高效，成就卓越团队</p>
					<p class="title1">
						每个业务环节都能始终保持畅通，无论是做了10年的老员工
						还是薪员工，都能轻松处理业务；销售人员的管理也变得轻而易举，
						只需要掏出手机，就能掌握客户跟进动态。
					</p>
				</div>
			</div>
			<div class="mobile_do_itemBox2">
				<div class="mobile_do_itemBox2_item">
					<div class="mobile_do_itemBox2_item_top">
						<img src="../../static/images/mobile_images/doItem2.png" />
					</div>
					<div class="mobile_do_itemBox2_item_bottom">
						<p class="title">精益求精，财务尽在掌握</p>
						<p class="title1">
							轻点一下，呈现最准确的各类报表，一键拉取，历史数据一览无余；
							资金点滴汇入，每一笔走向都清晰明了，高效的财务工作，催生更大
							回报的资金决策。
						</p>
					</div>
				</div>
				<div class="mobile_do_itemBox2_item">
					<div class="mobile_do_itemBox2_item_top">
						<img src="../../static/images/mobile_images/doItem3.png" />
					</div>
					<div class="mobile_do_itemBox2_item_bottom">
						<p class="title">智能响应，引领业务未来</p>
						<p class="title1">
							对货品存量了若指掌，第一时间影响订单，同时，多余的资金
							也得到释放；销售报表一目了然，让营销方案有据可依，与供应商的议价
							也变得容易起来，为企业创造更大的利润。
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="mobile_pattern" id="mobile_pattern">
			<p class="title">用互联网技术改变传统工作模式让企业经营管理更高效</p>
			<div class="mobile_pattern_bg">
				<img src="../../static/images/mobile_images/patternBg.png" />
			</div>
			<div class="mobile_pattern_itemBox">
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon1.png" />
					<span class="spanTitle">采购管理</span>
					<span class="spanTitle1">采购入库、入库详情</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon2.png" />
					<span class="spanTitle">库存管理</span>
					<span class="spanTitle1">仓库库存、整卷库存、盘库记录、库存历史</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon3.png" />
					<span class="spanTitle">客户管理</span>
					<span class="spanTitle1">客户资料管理(发展新客户、维系老客户)</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon4.png" />
					<span class="spanTitle">结算管理</span>
					<span class="spanTitle1">应收管理、应付管理、核销管理</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon5.png" />
					<span class="spanTitle">系统管理</span>
					<span class="spanTitle1">用户管理、角色管理、操作日志</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon6.png" />
					<span class="spanTitle">销售管理</span>
					<span class="spanTitle1">销售出库、出库草稿、出库详情、车辆运输、出库确认</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon7.png" />
					<span class="spanTitle">基础数据</span>
					<span class="spanTitle1">材料类型、钢材规格、仓库管理</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon8.png" />
					<span class="spanTitle">供应商管理</span>
					<span class="spanTitle1">供应商资料管理(多供应商接入)</span>
				</div>
				<div class="mobile_pattern_item">
					<img src="../../static/images/mobile_images/patternIcon9.png" />
					<span class="spanTitle">报表统计</span>
					<span class="spanTitle1">供应商统计、客户统计、入库规格、出库规格、出库统计、入库统计</span>
				</div>
			</div>
		</div>
		<div class="mobile_freeBtn">
			<div class="mobile_freeBtn_btn" @click="openWX()" v-if="!isWX">
				<span>免费试用</span>
				<img src="../../static/images/mobile_images/freeTrialIcon.png" />
			</div>
			<div class="mobile_freeBtn_btn"v-if="isWX">
					<wx-open-launch-weapp
						id="launch-btn"
						username="gh_d6cd78832555"
						path="pages/index/index"
					>
						<script type="text/wxtag-template">
							<button class="wx-btn">跳转小程序</button>
						</script>
					</wx-open-launch-weapp>
				<span>免费试用</span>
				<img src="../../static/images/mobile_images/freeTrialIcon.png" />
			</div>
		</div>
    <div class="mobile_payUser">
      <p>按用户计费,518/年 一个账户</p>
    </div>
    
		<div class="mobile_pay" id="mobile_pay" v-if="vipGoodsList.length>0">
			<div class="mobile_payItem item1" v-for="(item,index) in vipGoodsList" :key="item.id">
				<div class="mobile_payItem_message">
					<span class="paySymbol">￥</span>
					<span class="payPrice">{{item.price}}</span>
					<span class="paySymbol">元 / {{item.name}}</span>
				</div>
				<span class="mobile_payItem_song">{{item.content}}</span>
				<span class="mobile_payItem_payBtn payBtn1">
					<div class="mobile_payItem_payBtn_cc"  v-if="isWX">
						<wx-open-launch-weapp
							id="launch-btn"
							username="gh_d6cd78832555"
							path="pages/index/index"
						>
							<script type="text/wxtag-template">
								<button class="wx-btn">跳转小程序</button>
							</script>
						</wx-open-launch-weapp>
						<span >去支付</span>
					</div>
					<span @click="openWX()" v-if="!isWX">去支付</span>
				</span>
			</div>
			<!-- <div class="mobile_payItem item2">
				<div class="mobile_payItem_message">
					<span class="paySymbol">￥</span>
					<span class="payPrice">5999</span>
					<span class="paySymbol">元 / 2年</span>
				</div>
				<span class="mobile_payItem_song">送价值1999元12寸平电脑<br/>(默认10个账户)</span>
				<span class="mobile_payItem_payBtn payBtn2">去支付</span>
			</div> -->
			<!-- <div class="mobile_payItem item3">
				<div class="mobile_payItem_message">
					<span class="paySymbol">￥</span>
					<span class="payPrice">7999</span>
					<span class="paySymbol">元 / 3年</span>
				</div>
				<span class="mobile_payItem_song">送价值3999元55寸智能液晶电视<br/>(默认10个账户)</span>
				<span class="mobile_payItem_payBtn payBtn3">去支付</span>
			</div> -->
		</div>
		
		<div class="mobile_more">
			<img src="../../static/images/mobile_images/moreBg.png" />
		</div>
		<div class="mobile_port">
			<p class="title">多端匹配，契合用户使用习惯</p>
			<p class="title1"><span>方便用户</span><span>留住客户</span><span>营销客户</span></p>
			<div class="mobile_port_ItemBox">
				
				<div class="mobile_portItem"  v-if="isWX">
					<wx-open-launch-weapp
						id="launch-btn"
						username="gh_d6cd78832555"
						path="pages/index/index"
					>
						<script type="text/wxtag-template">
							<button class="wx-btn">跳转小程序</button>
						</script>
					</wx-open-launch-weapp>
					<img src="../../static/images/mobile_images/portIcon1.png" />
					<span>小程序</span>
				</div>
				<div class="mobile_portItem" @click="openWX()" v-if="!isWX">
					<img src="../../static/images/mobile_images/portIcon1.png" />
					<span>小程序</span>
				</div>
				<div class="mobile_portItem">
					<img src="../../static/images/mobile_images/portIcon2.png" />
					<span>PC端</span>
				</div>
				<div class="mobile_portItem">
					<img src="../../static/images/mobile_images/portIcon3.png" />
					<span>APP端</span>
				</div>
				<div class="mobile_portItem">
					<img src="../../static/images/mobile_images/portIcon4.png" />
					<span>微信端</span>
				</div>
			</div>
		</div>
		<div class="mobile_aboutUS" id="mobile_aboutUS">
			<p class="mobile_aboutUS_title">
				<span class="title">关于我们</span>
				<span class="title1">/ About Us</span>
			</p>
			<p class="content">
					广州蜂陶信息技术有限公司（简称“蜂陶信息”）是一家集软、硬件产品研发销售于一体的高新技术企业。致力于成为智慧安全出行解决方案、智慧农产品安全追溯解决方案、智慧安全巡检解决方案专家。蜂陶信息软、硬件产品广泛应用航空、交通运输、教育、医疗、物流、制造业、农业等行业。
			</p>
			<p class="content">
					蜂 -- 勤劳、敬业、专注、刚毅，不畏艰难勇往直前。
			</p>
			<p class="content">
					陶 -- 快乐、教育、培养、熏陶，分享成果授人以渔。
			</p>
			<p class="codeTitle">让管理与销售更贴近更轻松</p>
			<p class="codeTitle1">来钢贸，企业专属的一体化云端ERP</p>
			<div class="codeBox">
				<img src="../../static/images/mobile_images/wxCode.jpg" />
			</div>
		</div>
		<div class="mobile_footer">
			<div class="left">Copyright &copy; 2015 - {{year}} 广州蜂陶信息技术有限公司 版权所有</div>
		</div>
		<div class="mobile_top" @click="goTop" v-show="isTopShow">
			<img src="../../static/images/mobile_images/top.png" />
		</div>
	</div>
</template>
<script src="//res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
	export default {
		name: 'mobile_home',
		data() {
			return {
				isShow: false,
				swiperOption: {
					autoplay: 3000,
					speed: 1000,
					loop: true,
					pagination: {
						el: '.swiper-pagination'
					},
				},
				companyNum: '0',
				userNum: '0',
				year: 2019,
				isTopShow: false,
				scroll: '',
				isWX:false,
				vipGoodsList:[]
			}
		},
		methods: {
			showSide() {
				this.isShow = true
			},
			closeSide() {
				this.isShow = false
			},
			scrollTo(id) {
				var getid = document.getElementById(id);
				var height = getid.offsetTop
				// console.log(height)
				$("body,html").stop().animate({
					scrollTop: height
				}, 600)
			},
			goTop() {
				$("body,html").stop().animate({
					scrollTop: 0
				}, 600)
			},
			openWX(){
				console.log('进行点击小程序按钮事件');
				window.location.href = 'weixin://dl/business/?t=PY20A8YdSTt'
			},
			menu(e) {
				this.scroll = e.srcElement.scrollingElement.scrollTop
				if (this.scroll > 103) {
					this.isTopShow = true
				} else {
					this.isTopShow = false
				}
			},
			getCompanyVal(){
				this.axios.post('index/value/getVal',this.qs({key:'CompanyNum'})).then(res =>{
					// console.log(res)
					if(res.data.status == "success"){
						this.companyNum = res.data.data
						$('.companyNum').numberAnimate({num:this.companyNum,speed:5000,symbol:","})
					}
					
				})
			},
			getVipGoodsList(){
				this.axios.post('index/value/getVipGoodsList',null).then(res =>{
					if(res.data.status == "success"){
						this.vipGoodsList = res.data.data
					}
				})
			},
			getUserVal(){
				this.axios.post('index/value/getVal',this.qs({key:'UserNum'})).then(res =>{
					// console.log(res)
					if(res.data.status == "success"){
						this.userNum = res.data.data
						$('.userNum').numberAnimate({num:this.userNum,speed:5000,symbol:","})
					}
					
				})
			}
		},
		mounted() {
			var date = new Date;
			this.year = date.getFullYear()
			this.getUserVal()
			this.getCompanyVal()
			this.getVipGoodsList()
			if (/(iPhone|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
			    this.$router.push("/mobile_home")
			}else{
				this.$router.push("/")
			}
			// $(window).scroll(function() {
			// 	if ($(window).scrollTop() > 103) {
			// 		this.isTopShow = true
			// 	} else {
			// 		this.isTopShow = false
			// 	}
			// });
			window.addEventListener('scroll', this.menu)
			if(isWeiXin()){
				this.isWX = true
				createSign(); 
				
			}
		}
	}

	//请求微信授权
function createSign(){
	var url = window.location.href.split('#')[0];

	$.post("http://app.fengtaoxx.com/generator-web-boss/api/index/createSign.do",{url:url},function(res){
		weixin(res)
	})
}

//微信分享
function weixin(responsedata) {
	var _this = this
	wx.config({
		debug: false,
		appId: responsedata.appId,
		timestamp: responsedata.timestamp,
		nonceStr: responsedata.nonceStr,
		signature: responsedata.signature,
		openTagList: ['wx-open-launch-weapp'],
		jsApiList: [
			'onMenuShareTimeline',
			'onMenuShareAppMessage'
		]
	});
	wx.error(function(res) { 
		console.log('验证失败返回的信息:', res);
	});
	wx.ready(function() {
			var url =  'http://app.fengtaoxx.com';
		var title = '钢贸云';
		var desc = "钢贸云专注解决钢铁批发贸易公司开单、入库、结算难问题，帮助企业节能减排，提高企业经济效益";
		var imgUrl = "http://app.fengtaoxx.com/ft/images/logo2.jpg";
		
		wx.checkJsApi({
			jsApiList: [
				'onMenuShareTimeline',
				'onMenuShareAppMessage',
			]
		});
		/*分享到朋友圈*/
		wx.onMenuShareTimeline({
			title: title, // 分享标题
			desc: desc, // 分享描述
			imgUrl: imgUrl,
			link: url, // 分享链接
			success: function() {},
			cancel: function() {}
		});
		/*分享给朋友*/
		wx.onMenuShareAppMessage({
			title: title, // 分享标题
			desc: desc, // 分享描述
			link: url, // 分享链接
			imgUrl: imgUrl,
			success: function() {
				// console.log(url);
			},
			cancel: function() {}
		});
		var btn = document.getElementById('launch-btn');
		btn.addEventListener('launch', function (e) {
			console.log('success');
		});
		btn.addEventListener('error', function (e) {
			console.log('fail', e.detail);
		});
	});
}

//判断是不是微信浏览器 是返回true
function isWeiXin(){
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i) == 'micromessenger'){
		return true;
	}else{
		return false;
	}
}
	
</script>

<style>
	.mobile_home {
		background-color: #f5f5f5;
	}

	.mobile_home .mobile_home_head {
		display: flex;
		width: 100%;
		padding: 0.15rem 0.15rem 0.15rem 0.2rem;
		justify-content: space-between;
		align-items: center;
	}

	.mobile_home .mobile_home_head .head_logo img {
		width: 1.5rem;
		height: 0.53rem;
	}

	.mobile_home .mobile_home_head .head_icon img {
		width: 0.35rem;
		height: 0.3rem;
	}

	.mobile_home .mobile_home_sideEdge_con {
		position: fixed;
		background-color: #ccc;
		z-index: 1000;
		top: 0;
		right: 0;
		width: 50%;
		height: 100%;
		padding: 0.15rem;
	}

	.mobile_home .mobile_home_sideEdge_con .mobile_home_sideEdge_con_head {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 0.57rem;

	}

	.mobile_home .mobile_home_sideEdge_con .mobile_home_sideEdge_con_head span img {
		width: 0.4rem;
		height: 0.4rem;
	}

	.mobile_home .mobile_home_sideEdge_con ul {
		padding: 0.15rem 0;
		color: #fff;
	}

	.mobile_home .mobile_home_sideEdge_con ul li {
		padding: 0.1rem;
		display: flex;
		align-items: center;
	}

	.mobile_home .mobile_home_sideEdge_con ul li .mobile_home_sideEdge_con_icon {
		margin-right: 0.2rem;
	}

	.mobile_home .mobile_home_sideEdge_con ul li .mobile_home_sideEdge_con_icon img {
		width: 0.3rem;
		height: 0.35rem;
	}

	.mobile_home .mobile_home_sideEdge_con ul li .mobile_home_sideEdge_con_title {
		padding-top: 0.08rem;
	}

	.mobile_banner .swiperOption {
		width: 100%;
		height: 5.8rem;
	}

	.mobile_banner .swiperOption img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.mobile_number {
		height: 1.2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0.12rem;
		background-color: #fff;
	}

	.mobile_number .mobile_number_con {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item {
		display: flex;
		align-items: center;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .num {
		font-size: 0.3rem;
		font-weight: bold;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .num .mt-number-animate {
		font-size: 0.36rem !important;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .num .mt-number-animate .mt-number-animate-dom {
		width: 0.22rem;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .num .mt-number-animate .mt-number-animate-dot {
		width: 0.22rem;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .addText {
		padding: 0 0.05rem;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .title {
		font-size: 0.18rem;
	}

	.mobile_number .mobile_number_con .item1 {
		padding-right: 0.56rem;
	}

	.mobile_number .mobile_number_con .item2 {
		padding-left: 0.56rem;
	}

	.mobile_number .mobile_number_con .line {
		width: 1px;
		background-color: #eee;
		height: 0.5rem;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .blue {
		color: #1099f9;
	}

	.mobile_number .mobile_number_con .mobile_number_con_item .green {
		color: #0fcf81;
	}

	.mobile_introduce {
		background-color: #fff;
	}

	.mobile_introduce .mobile_introduce_title1 {
		font-size: 0.3rem;
		padding: 0.4rem 0.3rem 0 0.3rem;
		text-align: center;
		line-height: 0.5rem;
	}

	.mobile_introduce .mobile_introduce_title2 {
		font-size: 0.16rem;
		padding: 0.3rem 1rem 0 1rem;
		text-align: center;
		color: #8a8a8a;
	}

	.mobile_introduce .mobile_introduce_itemBox {
		display: flex;
		flex-flow: wrap;
		padding: 0.4rem 0.15rem;
		justify-content: space-between;
	}

	.mobile_introduce .mobile_introduce_itemBox .mobile_introduce_item {
		display: flex;
		width: 48%;
		height: 2.2rem;
		align-items: center;
		justify-content: center;
		border: 1px solid #e5e5e5;
		margin-bottom: 0.3rem;
		flex-direction: column;
		border-radius: 5px;

	}

	.mobile_introduce .mobile_introduce_itemBox .mobile_introduce_item img {
		width: 1.15rem;
		height: 1.15rem;
	}

	.mobile_introduce .mobile_introduce_itemBox .mobile_introduce_item span {
		padding-top: 0.2rem;
	}

	.mobile_do {
		background: url('../../static/images/mobile_images/doBg.png') no-repeat;
		color: #fff;
		padding: 0 0.15rem 0.5rem 0.15rem;
	}

	.mobile_do .mobile_do_title {
		text-align: center;
		font-size: 0.28rem;
		padding-top: 0.36rem;
	}

	.mobile_do .mobile_do_title1 {
		text-align: center;
		font-size: 0.18rem;
		padding-top: 0.2rem;
	}

	.mobile_do .mobile_do_itemBox1 {
		display: flex;
		border-radius: 5px;
		padding-top: 0.2rem;
	}

	.mobile_do .mobile_do_itemBox1 .mobile_do_itemBox1_left {
		width: 50%;
	}

	.mobile_do .mobile_do_itemBox1 .mobile_do_itemBox1_left img {
		width: 100%;
		height: 100%;
		border-radius: 5px 0 0 5px;
		object-fit: cover;
	}

	.mobile_do .mobile_do_itemBox1 .mobile_do_itemBox1_right {
		width: 50%;
		background-color: #fff;
		padding: 0.25rem 0.25rem 0.35rem 0.2rem;
		border-radius: 0 5px 5px 0;
	}

	.mobile_do .mobile_do_itemBox1 .mobile_do_itemBox1_right .title {
		font-size: 0.28rem;
		text-align: center;
		color: #000;
	}

	.mobile_do .mobile_do_itemBox1 .mobile_do_itemBox1_right .title1 {
		font-size: 0.22rem;
		color: #5e5e5e;
		padding-top: 0.15rem;
		line-height: 0.4rem;
	}

	.mobile_do .mobile_do_itemBox2 {
		display: flex;
		justify-content: space-between;
		padding-top: 0.2rem;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item {
		width: 48%;
		display: flex;
		flex-direction: column;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item .mobile_do_itemBox2_item_top {
		height: 2rem;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item .mobile_do_itemBox2_item_top img {
		width: 100%;
		height: 100%;
		border-radius: 5px 5px 0 0;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item .mobile_do_itemBox2_item_bottom {
		background-color: #fff;
		padding: 0.15rem;
		border-radius: 0 0 5px 5px;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item .mobile_do_itemBox2_item_bottom .title {
		color: #000;
		text-align: center;
		font-size: 0.28rem;
		padding-top: 0.15rem;
	}

	.mobile_do .mobile_do_itemBox2 .mobile_do_itemBox2_item .mobile_do_itemBox2_item_bottom .title1 {
		color: #5e5e5e;
		padding-top: 0.15rem;
		font-size: 0.22rem;
		line-height: 0.4rem;
		height: 3rem;
	}

	.mobile_pattern {
		background-color: #fff;
	}

	.mobile_pattern .title {
		text-align: center;
		font-size: 0.3rem;
		padding-top: 0.5rem;
	}

	.mobile_pattern .mobile_pattern_bg img {
		width: 100%;
	}

	.mobile_pattern .mobile_pattern_itemBox {
		padding: 0.4rem 0.15rem;
		display: flex;
		justify-content: space-between;
		flex-flow: wrap;
	}

	.mobile_pattern .mobile_pattern_itemBox .mobile_pattern_item {
		width: 30%;
		border-radius: 5px;
		border: 1px solid #eee;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 0.2rem;
		padding: 0.2rem 0;
	}

	.mobile_pattern .mobile_pattern_itemBox .mobile_pattern_item img {
		width: 0.66rem;
		height: 0.66rem;
	}

	.mobile_pattern .mobile_pattern_itemBox .mobile_pattern_item .spanTitle {
		font-size: 0.2rem;
		text-align: center;
		padding-top: 0.15rem;
	}

	.mobile_pattern .mobile_pattern_itemBox .mobile_pattern_item .spanTitle1 {
		font-size: 0.15rem;
		text-align: center;
		padding-top: 0.15rem;
	}

	.mobile_freeBtn {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
	}

	.mobile_freeBtn .mobile_freeBtn_btn {
		width: 2.3rem;
		height: 0.6rem;
		border-radius: 0.3rem;
		border: 1px solid #1c89ff;
		display: flex;
		align-items: center;
		color: #1c89ff;
		position: relative;
		padding-left: 0.5rem;
	}

	.mobile_freeBtn .mobile_freeBtn_btn img {
		width: 0.25rem;
		height: 0.25rem;
		position: absolute;
		top: 0.15rem;
		right: 0.2rem;
	}
  .mobile_payUser{
    font-size: 0.18rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding-top: 0.2rem;
  }
  .mobile_payUser p{
    text-align: center;
    color: orange;
    height: 0.3rem;
    line-height: 0.3rem;
    width: 4rem;
    background-color: #df5f1f;
    border-radius: 5px;
    color: #fff;
  }
	.mobile_pay {
		width: 100%;
		background-color: #fff;
		padding: 0.2rem 0.15rem 0.45rem 0.15rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.mobile_pay .mobile_payItem {
		width: 48%;
		border-radius: 5px;
		color: #fff;
		flex-direction: column;
		display: flex;
		padding: 0.24rem 0.15rem;
		justify-content: center;
		height: 3rem;
		margin-bottom: 0.2rem;
		box-sizing: border-box;
	}

	.mobile_pay .item1:nth-child(3n-2) {
		background: url('../../static/images/mobile_images/payBg.png') no-repeat;
	}

	.mobile_pay .item1:nth-child(3n-1) {
		background: url('../../static/images/mobile_images/payBg2.png') no-repeat;
	}

	.mobile_pay .item1:nth-child(3n) {
		background: url('../../static/images/mobile_images/payBg3.png') no-repeat;
	}

	.mobile_pay .mobile_payItem .mobile_payItem_message {
		text-align: center;
	}

	.mobile_pay .mobile_payItem .mobile_payItem_message .payPrice {
		font-size: 0.32rem;
		font-weight: bold;
	}

	.mobile_pay .mobile_payItem .mobile_payItem_message .paySymbol {
		font-size: 0.18rem;
	}

	.mobile_pay .mobile_payItem .mobile_payItem_song {
		font-size: 0.15rem;
		text-align: center;
		height: 1.5rem;
	}

	.mobile_pay .mobile_payItem .mobile_payItem_payBtn {
		width: 2rem;
		height: 0.36rem;
		background-color: #fff;
		border-radius: 0.18rem;
		font-size: 0.16rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
		position: relative;
	}

	.mobile_pay .mobile_payItem .payBtn1 {
		color: #3ed87b;
	}

	.mobile_pay .mobile_payItem .payBtn2 {
		color: #9842fa;
	}

	.mobile_pay .mobile_payItem .payBtn3 {
		color: #fd9225;
	}

	.mobile_more {
		width: 100%;
	}

	.mobile_more img {
		width: 100%;
	}

	.mobile_port {
		background-color: #fff;
		padding: 0.4rem 0.15rem;
		border-bottom: 1px solid #e2e2e2;
	}

	.mobile_port .title {
		font-size: 0.28rem;
		text-align: center;
	}

	.mobile_port .title1 {
		font-size: 0.18rem;
		text-align: center;
		padding-top: 0.2rem;
	}

	.mobile_port .title1 span {
		margin-left: 0.2rem;
	}

	.mobile_port .title1 span:first-child {
		margin-left: 0rem;
	}

	.mobile_port .mobile_port_ItemBox {
		display: flex;
		justify-content: space-between;
		padding-top: 0.25rem;
	}

	.mobile_port .mobile_port_ItemBox .mobile_portItem {
		width: 24%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.mobile_port .mobile_port_ItemBox .mobile_portItem img {
		width: 1.45rem;
		height: 1.45rem;
	}

	.mobile_port .mobile_port_ItemBox .mobile_portItem span {
		font-size: 0.18rem;
		padding-top: 0.15rem;
	}

	.mobile_aboutUS {
		padding: 0.34rem 0.4rem;
		background-color: #fff;
	}

	.mobile_aboutUS .mobile_aboutUS_title .title {
		font-size: 0.24rem;
	}

	.mobile_aboutUS .mobile_aboutUS_title .title1 {
		font-size: 0.16rem;
		color: #8a8a8a;
	}

	.mobile_aboutUS .mobile_aboutUS_content {
		color: #8a8a8a;
		font-size: 0.16rem;
		line-height: 0.3rem;
	}

	.mobile_aboutUS .codeTitle {
		font-size: 0.32rem;
		text-align: center;
		padding-top: 0.4rem;
	}

	.mobile_aboutUS .codeTitle1 {
		padding-top: 0.1rem;
		font-size: 0.18rem;
		color: #8a8a8a;
		text-align: center;
	}

	.mobile_aboutUS .codeBox {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 0.2rem;
	}

	.mobile_aboutUS .codeBox img {
		width: 3rem;
		height: 3rem;
		border: 1px solid #eee;
	}

	.mobile_footer {
		background-color: #1f1f1f;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666;
		font-size: 0.18rem;
		height: 0.5rem;
	}

	.mobile_top {
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		right: 0.3rem;
		bottom: 0.5rem;
		z-index: 999;
	}

	.mobile_top img {
		width: 0.6rem;
		height: 0.6rem;
	}
	#launch-btn{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		display: block;
		opacity: 0;
		z-index: 555;
	}
	.mobile_payItem_payBtn_cc{
		display: flex;
		width: 100%;
    height: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/mobile_home.vue